(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sr-christmas-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sr-christmas-strip')) {
  customElements.define('sr-christmas-strip', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-ready')) return;
      const button = this.querySelector('button');
      if (!button) return;
      button.hidden = false;
      this.setAttribute('data-ready', '');
      button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
        button.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
